import {useCheckboxSelection} from "../Checkbox";
import {Button, Grid, Menu, MenuItem} from "@mui/material";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useTableData} from "../../../../misc/scroller/Table";
import {logisticsTableName} from "./Logistics";
import {useProjectId} from "../ProjectName";
import {Loader} from "../../../../misc/Loader";
import {InventoryRequest} from "../../../../api/Logistics";

export function canSendDuplicate(row: InventoryRequest) {
    return row.status !== "not-released" && row.type !== "component";
}

export function BulkSendDuplicate(props: {
    type: string;
    anchorEl: HTMLElement | null;
    onOpen(): void;
}) {
    const sel = useCheckboxSelection()
    const [open, setOpen] = useState(false);
    const project = useProjectId();
    const nav = useNavigate();
    const data = useTableData(logisticsTableName(project, props.type)) as InventoryRequest[]
    const values = data.filter(d => sel.indexOf(d.id) !== -1 && canSendDuplicate(d));

    const send = useAsyncAction(async (input: {ids: number[]; project: number}) => {
        await api.logistics.sendDuplicate(input);
        setOpen(false);
        nav(`/project/${project}/logictrl/changes`);
    }, [nav, project]);

    return <>
        <MenuItem disabled={values.length === 0} onClick={() => {
            props.onOpen();
            setOpen(true);
        }}>Send Duplicate</MenuItem>

        {open && <Menu open anchorEl={props.anchorEl} onClose={() => setOpen(false)}>
            <Loader {...send} />
            <div style={{padding: 16, maxWidth: 400}}>
                This will queue a duplicate of {values.length} logistics item(s) in a changeset.
                The new items are created when the changeset is approved.
            </div>
            <Grid container spacing={1} justifyContent="flex-end" style={{paddingRight: 10, paddingBottom: 8}}>
                <Grid item>
                    <Button onClick={() => setOpen(false)} size="small">Cancel</Button>
                </Grid>
                <Grid item>
                    <Button disabled={send.loading} onClick={() => send.callback({
                        ids: values.map(v => v.id),
                        project: project,
                    })} variant="contained" size="small">Send Duplicate</Button>
                </Grid>
            </Grid>
        </Menu>}
    </>
}
